import { createContext } from "react";
import { BiometricTypeEnum } from "../types/biometric-type-enum";

type PasswordlessContextValues = {
	biometricType?: BiometricTypeEnum;
	showBiomatricToast?: boolean;
	setShowBiometricToast: (show: boolean) => void;
	setPasswordlessOn: () => Promise<boolean>;
	setPasswordlessOff: () => void;
	passwordlessEnabled: boolean;
	isLoading: boolean;
};

export const PasswordlessContext = createContext<PasswordlessContextValues | undefined>(undefined);
